function adjustPositionPopup(){

  if($(".bundle-promo-items.four-items").length){
const activePromoItem = document.querySelector('.bundle-promo-item.active');

// Select the popup content
const popupContent = document.querySelector('.bundle-promo-item.active .bundle-popup_content');

if (activePromoItem && popupContent) {
  // Get the bounding rectangle of the promo item relative to viewport
  const rect = activePromoItem.getBoundingClientRect();

  // Position the popup fixed to the promo item
  popupContent.style.position = 'fixed';
  popupContent.style.top = `${rect.top}px`;
  popupContent.style.left = `${rect.left + rect.width / 2 - popupContent.offsetWidth / 2}px`;
  popupContent.style.transform = "translateY(-90%)";


  // Optionally, adjust if needed:
  // e.g., if you want it *below* the promo item
  // popupContent.style.top = `${rect.bottom}px`;

}
  }

}

$(document).ready(function () {
  if (window.innerWidth > 769) {
  $('.bundle-promo-img-cont').on('click', function () {
    var attd = $(this).closest('.bundle-promo-item').attr('data-name')
    const $popupbnd = $('.bundle-popup[data-name="' + attd + '"]');
    if ($popupbnd.length) {
      $popupbnd.addClass('active');
      $popupbnd.closest('.bundle-promo-item').addClass('active');
      $popupbnd.closest('.bundle-promo-item').prev().addClass('hide');
      $('html').addClass('open-popup');
      console.log('test')
      adjustPositionPopup()
    }
  });

  $('.bundle-popup_close, .bundle-popup_overlay').on('click', function () {
    $(this).closest('.bundle-popup').removeClass('active');
    $('.bundle-promo-item').removeClass('active')
    $('.bundle-promo-item').removeClass('hide')
    console.log('test2')
     setTimeout(function(){ 
$('html').removeClass('open-popup');
}, 100);
    
  });

  $('.strength-upgrade-image').on('click', function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    const $popupstr = $(this).closest('.strength-upgrade-product').find('.strength-popup');
    if ($popupstr.length) {
      $popupstr.addClass('active');
       setTimeout(function(){ 
 $('html').addClass('open-popup');
}, 100);
     
    }
  });

  $('.strength-popup_close, .strength-popup_overlay').on('click', function () {
    $(this).closest('.strength-popup').removeClass('active');
     setTimeout(function(){ 
 $('html').removeClass('open-popup');
}, 100);
  });

     setInterval(function(){ 
adjustPositionPopup()
}, 50);
}

  $(".product__title").append($("[id*=reviews_preview_badge]"));
});